import { FlexBox } from '@dixa/lib-shared-habla';

import { AiAgentMessage, ConversationAuditLogEntry } from 'apis/auditLogs';

import { LogEntry } from '../logEntry';
import { SidekickDebugButton } from '../sidekickDebugButton/sidekickDebugButton';
import { createAiAgentDraftDebugPrompt } from '../sidekickDebugButton/sidekickDebugButton.utils';

import { MessageEntryRow } from './messageEntryRow';
import { ThinkingEntryRow } from './thinkingEntryRow';
import { ToolCallEntryRow } from './toolCallEntryRow';

type AiAgentDraftProps = {
  entry: ConversationAuditLogEntry<'AI_AGENT_DRAFT'>;
};

export const AiAgentDraft = ({ entry }: AiAgentDraftProps): JSX.Element => {
  const draft = entry.entries.findLast(
    (draftEntry): draftEntry is AiAgentMessage =>
      draftEntry.type === 'message' &&
      draftEntry.role.toLowerCase() === 'assistant',
  );

  return (
    <LogEntry
      entry={entry}
      icon="file-draft"
      text="AI agent draft"
      actions={
        <SidekickDebugButton
          label="Debug this AI draft"
          request={createAiAgentDraftDebugPrompt({
            csid: entry.resource.id,
            date: entry.event_timestamp,
            aiAgentName: entry.ai_agent?.name,
            draft: draft?.content,
          })}
        />
      }
      isExpandable
    >
      <FlexBox margin="200 0 0 500" gap="200" flexDirection="column">
        {entry.entries.map((draftEntry, index) => {
          if (draftEntry.type === 'message') {
            return (
              <MessageEntryRow
                key={index}
                role={draftEntry.role}
                content={draftEntry.content}
              />
            );
          }

          if (
            draftEntry.tool_type === 'STATIC' &&
            draftEntry.tool_name === 'think'
          ) {
            return (
              <ThinkingEntryRow
                key={index}
                output={draftEntry.output}
                execution_data={draftEntry.execution_data}
              />
            );
          }

          if (draftEntry.tool_type === 'STATIC') {
            return null;
          }

          return (
            <ToolCallEntryRow
              key={index}
              tool_type={draftEntry.tool_type}
              tool_name={draftEntry.tool_name}
              input={draftEntry.input}
              output={draftEntry.output}
              execution_data={draftEntry.execution_data}
              parent={draftEntry.parent}
            />
          );
        })}
      </FlexBox>
    </LogEntry>
  );
};
